export default __webpack_public_path__ + "static/media/x_cross.adfca78c.png";